import React, { useContext, useEffect, useState } from "react";
import "./Bank_Account.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../utils/context";
import { GetAllBanks, SetSelectedBank } from "../../features/wallet/slice";
import { FaCheckCircle } from "react-icons/fa";

function Bank_Account() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signin } = useContext(Context);

  const allBanks = useSelector((state) => state.wallet.banks);
  const selectedBank = useSelector((state) => state.wallet.selectedBank);


  const [selectedId, setSelectedId] = useState(() => {
    const saved = localStorage.getItem("selected_bank_id");
    return saved ? Number(saved) : null;
  });

  useEffect(() => {
    if (signin) dispatch(GetAllBanks({}));
  }, [dispatch, signin]);


  useEffect(() => {
    if (allBanks?.length && selectedId && !selectedBank) {
      const saved = allBanks.find((b) => b.id === selectedId);
      if (saved) dispatch(SetSelectedBank(saved));
    }
    if (allBanks?.length === 0) {
      localStorage.removeItem("selected_bank_id");
    }
  }, [allBanks, selectedId, selectedBank, dispatch]);

  useEffect(() => {
    if (selectedBank?.id) setSelectedId(selectedBank.id);
  }, [selectedBank]);

  const handleSelect = (bank) => {
    setSelectedId(bank);
    dispatch(SetSelectedBank(bank));
    localStorage.setItem("selected_bank_id", bank.id);
  };

  return (
    <section className="Bank_Account">
      <Common_white_header headingText={"Bank Account"} />

      <div className="container">
        {allBanks?.map((data) => (
          <div
            key={data.id}
            className={`bank-details-card ${selectedId === data.id ? "selected" : ""}`}
            onClick={() => handleSelect(data)}
            style={{ cursor: "pointer", position: "relative" }}
          >

            <div className="bank-row">
              <span className="label">Bank name</span>
              <span className="value">{data?.bank_name || "N/A"}</span>
            </div>

            <div className="bank-row">
              <span className="label">Bank Account number</span>
              <span className="value">{data?.account_number || "N/A"}</span>
            </div>

            <div className="bank-row">
              <span className="label">Phone number</span>
              <span className="value">{data?.contact_no || "N/A"}</span>
            </div>

            <div className="bank-row">
              <span className="label">IFSC Code</span>
              <span className="value">{data?.ifsc_code || "N/A"}</span>
            </div>

            <div className="bank-row">
              <span className="label">UPI ID</span>
              <span className="value">{data?.upi_id || "N/A"}</span>
            </div>
            <hr></hr>
            {/* Rendered last so it overlays without affecting layout */}
            {/* {selectedId === data.id && (
              <FaCheckCircle
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  color: "#37BB80",
                  fontSize: "18px",
                  pointerEvents: "none",
                }}
              />
            )} */}
          </div>
        ))}

        {/* Confirm + Add Bank */}
        <div className="add-bank-section">
          {selectedId && allBanks?.length > 0 && (
            <button
              className="btn_register_bg mb-3"
              onClick={() => navigate(-1)}
            >
              Confirm Selection
            </button>
          )}
          <button
            className="btn_register_bg"
            onClick={() => navigate("/add-bank-account")}
          >
            Add a Bank Account
          </button>
        </div>
      </div>
    </section>
  );
}

export default Bank_Account;